export default "__VITE_ASSET__CHOVUz5G__"